/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 3;
export const EdgeFinish = new EnumReflection('EdgeFinish', {
    enum: [
        'Standard',
        'Facet',
        'Round'
    ]
});
export const FenixVariant = new EnumReflection('FenixVariant', {
    enum: [
        'None',
        'Birch',
        'Solid'
    ]
});
export const LegsThickness = new EnumReflection('LegsThickness', {
    enum: [
        'Thick',
        'Thin'
    ]
});
export const TopColorCeramic = new EnumReflection('TopColorCeramic', {
    enum: [
        'CuarzoReno',
        'NeroZimbabwe',
        'BiancoSupreme',
        'CalacataVaglie',
        'TajMahal',
        'MacchiaVecchia',
        'CarraraNaturel',
        'CalacataNaturel',
        'BlueStoneNegro',
        'CeppoDeGre',
        'NeroArdi',
        'PaladioNaturel',
        'NegroAbsoluto',
        'CalceGrigio',
        'TitanCemento',
        'TitanAntracita',
        'LavaIron',
        'LavaCorten',
        'BasicNegroNaturel',
        'BasicBlanco',
        'Travertin',
        'CalacataGold',
        'SurfaceSand',
        'SurfaceOffWhite',
        'NoirDesir',
        'SurfaceCoolGrey',
        'HyperWhite',
        'DarkBlack',
        'ClassicCarrara'
    ]
});
export const TopColorFenix = new EnumReflection('TopColorFenix', {
    enum: [
        'BiancoKos0032',
        'BeigeLuxor0719',
        'NeroIngo0720',
        'VerdeComodoro0750',
        'VerdeBrac0773'
    ]
});
export const ColorOak = new EnumReflection('ColorOak', {
    enum: [
        'UltraMatteLak',
        'Oyster',
        'DarkOak',
        'Charcoal',
        'SlateGrey',
        'CottonWhite',
        'Black'
    ]
});
export const TopColor = new AjvReflection('TopColor', {
    anyOf: [
        TopColorCeramic._meta.schema,
        TopColorFenix._meta.schema,
        ColorOak._meta.schema
    ]
});
export const TopFinish = new EnumReflection('TopFinish', {
    enum: [
        'None',
        'NewOak',
        'LivedOak',
        'RefinedOak'
    ]
});
export const TopMaterial = new EnumReflection('TopMaterial', {
    enum: [
        'SolidOak',
        'Ceramic',
        'Fenix'
    ]
});
export const LegsColorSteel = new EnumReflection('LegsColorSteel', {
    enum: [
        'RAL9005',
        'RAL9016',
        'AnodicGold',
        'AnodicBronze',
        'AnodicBrown'
    ]
});
const TableShape = new AjvReflection('TableShape', {
    type: 'object',
    properties: {
        height: {
            type: 'number'
        },
        legsId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        topId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        }
    },
    additionalProperties: false,
    required: [
        'height',
        'legsId',
        'topId'
    ]
});
const SteelLegsShape = new AjvReflection('SteelLegsShape', {
    type: 'object',
    properties: {
        color: LegsColorSteel._meta.schema
    },
    additionalProperties: false,
    required: [
        'color'
    ]
});
const LegsWithOffsetShape = new AjvReflection('LegsWithOffsetShape', {
    type: 'object',
    properties: {
        legOffset: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'legOffset'
    ]
});
const LegsWithThicknessShape = new AjvReflection('LegsWithThicknessShape', {
    type: 'object',
    properties: {
        legThickness: LegsThickness._meta.schema
    },
    additionalProperties: false,
    required: [
        'legThickness'
    ]
});
const TopShape = new AjvReflection('TopShape', {
    type: 'object',
    properties: {
        color: TopColor._meta.schema,
        material: TopMaterial._meta.schema,
        fenixVariant: FenixVariant._meta.schema,
        topFinish: TopFinish._meta.schema,
        thickness: {
            type: 'number'
        },
        edgeFinish: EdgeFinish._meta.schema
    },
    additionalProperties: false,
    required: [
        'color',
        'material',
        'fenixVariant',
        'topFinish',
        'thickness',
        'edgeFinish'
    ]
});
const TopCircleShape = new AjvReflection('TopCircleShape', {
    type: 'object',
    properties: {
        diameter: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'diameter'
    ]
});
const TopWithLengthAndWidthShape = new AjvReflection('TopWithLengthAndWidthShape', {
    type: 'object',
    properties: {
        length: {
            type: 'number'
        },
        width: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'length',
        'width'
    ]
});
export const Table = new DomainEntityReflection('Table', [
    TableShape._meta.schema
]);
export const TopCircle = new DomainEntityReflection('TopCircle', [
    TopCircleShape._meta.schema,
    TopShape._meta.schema
]);
export const TopDanishOval = new DomainEntityReflection('TopDanishOval', [
    TopShape._meta.schema,
    TopWithLengthAndWidthShape._meta.schema
]);
export const TopHalfCircle = new DomainEntityReflection('TopHalfCircle', [
    TopShape._meta.schema,
    TopWithLengthAndWidthShape._meta.schema
]);
export const TopHalfOval = new DomainEntityReflection('TopHalfOval', [
    TopShape._meta.schema,
    TopWithLengthAndWidthShape._meta.schema
]);
export const TopOval = new DomainEntityReflection('TopOval', [
    TopShape._meta.schema,
    TopWithLengthAndWidthShape._meta.schema
]);
export const TopRectangle = new DomainEntityReflection('TopRectangle', [
    TopShape._meta.schema,
    TopWithLengthAndWidthShape._meta.schema
]);
export const Legs3D = new DomainEntityReflection('Legs3D', [
    SteelLegsShape._meta.schema
]);
export const Legs3DRonde = new DomainEntityReflection('Legs3DRonde', [
    LegsWithThicknessShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsAxel = new DomainEntityReflection('LegsAxel', [
    SteelLegsShape._meta.schema
]);
export const LegsBrago = new DomainEntityReflection('LegsBrago', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsButterfly = new DomainEntityReflection('LegsButterfly', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsClassico = new DomainEntityReflection('LegsClassico', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsCono = new DomainEntityReflection('LegsCono', []);
export const LegsDiamond = new DomainEntityReflection('LegsDiamond', [
    SteelLegsShape._meta.schema
]);
export const LegsEbonuEik = new DomainEntityReflection('LegsEbonuEik', []);
export const LegsEbonuStaal = new DomainEntityReflection('LegsEbonuStaal', [
    SteelLegsShape._meta.schema
]);
export const LegsEbonu3Eik = new DomainEntityReflection('LegsEbonu3Eik', []);
export const LegsEbonu3Staal = new DomainEntityReflection('LegsEbonu3Staal', [
    SteelLegsShape._meta.schema
]);
export const LegsEbonu3DoubleEik = new DomainEntityReflection('LegsEbonu3DoubleEik', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsEbonu3DoubleStaal = new DomainEntityReflection('LegsEbonu3DoubleStaal', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsEbu = new DomainEntityReflection('LegsEbu', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsElmo = new DomainEntityReflection('LegsElmo', []);
export const LegsElmoDouble = new DomainEntityReflection('LegsElmoDouble', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsFalke = new DomainEntityReflection('LegsFalke', [
    SteelLegsShape._meta.schema
]);
export const LegsFly = new DomainEntityReflection('LegsFly', [
    SteelLegsShape._meta.schema
]);
export const LegsHarper = new DomainEntityReflection('LegsHarper', [
    SteelLegsShape._meta.schema
]);
export const LegsHarper3 = new DomainEntityReflection('LegsHarper3', [
    SteelLegsShape._meta.schema
]);
export const LegsJulio3 = new DomainEntityReflection('LegsJulio3', [
    SteelLegsShape._meta.schema
]);
export const LegsJulio4 = new DomainEntityReflection('LegsJulio4', [
    SteelLegsShape._meta.schema
]);
export const LegsLivio = new DomainEntityReflection('LegsLivio', []);
export const LegsLivioSchuinEik = new DomainEntityReflection('LegsLivioSchuinEik', []);
export const LegsLivioSchuinStaal = new DomainEntityReflection('LegsLivioSchuinStaal', [
    SteelLegsShape._meta.schema
]);
export const LegsMadrid = new DomainEntityReflection('LegsMadrid', [
    SteelLegsShape._meta.schema
]);
export const LegsMPootRecht = new DomainEntityReflection('LegsMPootRecht', [
    LegsWithThicknessShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsMPootSchuin = new DomainEntityReflection('LegsMPootSchuin', [
    SteelLegsShape._meta.schema
]);
export const LegsNewly = new DomainEntityReflection('LegsNewly', [
    SteelLegsShape._meta.schema
]);
export const LegsNovaroEik = new DomainEntityReflection('LegsNovaroEik', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsNovaroStaal = new DomainEntityReflection('LegsNovaroStaal', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsOdil3 = new DomainEntityReflection('LegsOdil3', [
    SteelLegsShape._meta.schema
]);
export const LegsOdil4 = new DomainEntityReflection('LegsOdil4', [
    SteelLegsShape._meta.schema
]);
export const LegsOslo = new DomainEntityReflection('LegsOslo', []);
export const LegsOxford = new DomainEntityReflection('LegsOxford', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsPapillon = new DomainEntityReflection('LegsPapillon', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsPapillonStrak = new DomainEntityReflection('LegsPapillonStrak', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsPino = new DomainEntityReflection('LegsPino', [
    SteelLegsShape._meta.schema
]);
export const LegsRafino = new DomainEntityReflection('LegsRafino', [
    SteelLegsShape._meta.schema
]);
export const LegsRobuEik = new DomainEntityReflection('LegsRobuEik', []);
export const LegsRobuStaal = new DomainEntityReflection('LegsRobuStaal', [
    SteelLegsShape._meta.schema
]);
export const LegsRobuDoubleEik = new DomainEntityReflection('LegsRobuDoubleEik', [
    LegsWithOffsetShape._meta.schema
]);
export const LegsRobuDoubleStaal = new DomainEntityReflection('LegsRobuDoubleStaal', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsRoia = new DomainEntityReflection('LegsRoia', [
    SteelLegsShape._meta.schema
]);
export const LegsTPoot = new DomainEntityReflection('LegsTPoot', [
    SteelLegsShape._meta.schema
]);
export const LegsTPootRonde = new DomainEntityReflection('LegsTPootRonde', [
    SteelLegsShape._meta.schema
]);
export const LegsTrapezium = new DomainEntityReflection('LegsTrapezium', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsTwist3 = new DomainEntityReflection('LegsTwist3', [
    SteelLegsShape._meta.schema
]);
export const LegsTwist4 = new DomainEntityReflection('LegsTwist4', [
    SteelLegsShape._meta.schema
]);
export const LegsUPoot = new DomainEntityReflection('LegsUPoot', [
    LegsWithOffsetShape._meta.schema,
    LegsWithThicknessShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const LegsXPoot = new DomainEntityReflection('LegsXPoot', [
    LegsWithOffsetShape._meta.schema,
    SteelLegsShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Table,
    TopCircle,
    TopDanishOval,
    TopHalfCircle,
    TopHalfOval,
    TopOval,
    TopRectangle,
    Legs3D,
    Legs3DRonde,
    LegsAxel,
    LegsBrago,
    LegsButterfly,
    LegsClassico,
    LegsCono,
    LegsDiamond,
    LegsEbonuEik,
    LegsEbonuStaal,
    LegsEbonu3Eik,
    LegsEbonu3Staal,
    LegsEbonu3DoubleEik,
    LegsEbonu3DoubleStaal,
    LegsEbu,
    LegsElmo,
    LegsElmoDouble,
    LegsFalke,
    LegsFly,
    LegsHarper,
    LegsHarper3,
    LegsJulio3,
    LegsJulio4,
    LegsLivio,
    LegsLivioSchuinEik,
    LegsLivioSchuinStaal,
    LegsMadrid,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsNewly,
    LegsNovaroEik,
    LegsNovaroStaal,
    LegsOdil3,
    LegsOdil4,
    LegsOslo,
    LegsOxford,
    LegsPapillon,
    LegsPapillonStrak,
    LegsPino,
    LegsRafino,
    LegsRobuEik,
    LegsRobuStaal,
    LegsRobuDoubleEik,
    LegsRobuDoubleStaal,
    LegsRoia,
    LegsTPoot,
    LegsTPootRonde,
    LegsTrapezium,
    LegsTwist3,
    LegsTwist4,
    LegsUPoot,
    LegsXPoot
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Table
]);
export const Top = new RawAliasReflection('Top', [
    TopCircle,
    TopDanishOval,
    TopHalfCircle,
    TopHalfOval,
    TopOval,
    TopRectangle
]);
export const TopWithLengthAndWidth = new RawAliasReflection('TopWithLengthAndWidth', [
    TopDanishOval,
    TopHalfCircle,
    TopHalfOval,
    TopOval,
    TopRectangle
]);
export const Legs = new RawAliasReflection('Legs', [
    Legs3D,
    Legs3DRonde,
    LegsAxel,
    LegsBrago,
    LegsButterfly,
    LegsClassico,
    LegsCono,
    LegsDiamond,
    LegsEbonuEik,
    LegsEbonuStaal,
    LegsEbonu3Eik,
    LegsEbonu3Staal,
    LegsEbonu3DoubleEik,
    LegsEbonu3DoubleStaal,
    LegsEbu,
    LegsElmo,
    LegsElmoDouble,
    LegsFalke,
    LegsFly,
    LegsHarper,
    LegsHarper3,
    LegsJulio3,
    LegsJulio4,
    LegsLivio,
    LegsLivioSchuinEik,
    LegsLivioSchuinStaal,
    LegsMadrid,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsNewly,
    LegsNovaroEik,
    LegsNovaroStaal,
    LegsOdil3,
    LegsOdil4,
    LegsOslo,
    LegsOxford,
    LegsPapillon,
    LegsPapillonStrak,
    LegsPino,
    LegsRafino,
    LegsRobuEik,
    LegsRobuStaal,
    LegsRobuDoubleEik,
    LegsRobuDoubleStaal,
    LegsRoia,
    LegsTPoot,
    LegsTPootRonde,
    LegsTrapezium,
    LegsTwist3,
    LegsTwist4,
    LegsUPoot,
    LegsXPoot
]);
export const LegsEbonu = new RawAliasReflection('LegsEbonu', [
    LegsEbonuEik,
    LegsEbonuStaal
]);
export const LegsEbonu3 = new RawAliasReflection('LegsEbonu3', [
    LegsEbonu3Eik,
    LegsEbonu3Staal
]);
export const LegsEbonu3Double = new RawAliasReflection('LegsEbonu3Double', [
    LegsEbonu3DoubleEik,
    LegsEbonu3DoubleStaal
]);
export const LegsLivioSchuin = new RawAliasReflection('LegsLivioSchuin', [
    LegsLivioSchuinEik,
    LegsLivioSchuinStaal
]);
export const LegsNovaro = new RawAliasReflection('LegsNovaro', [
    LegsNovaroEik,
    LegsNovaroStaal
]);
export const LegsRobu = new RawAliasReflection('LegsRobu', [
    LegsRobuEik,
    LegsRobuStaal
]);
export const LegsRobuDouble = new RawAliasReflection('LegsRobuDouble', [
    LegsRobuDoubleEik,
    LegsRobuDoubleStaal
]);
export const LegsWithDiameter = new RawAliasReflection('LegsWithDiameter', [
    Legs3DRonde,
    LegsCono,
    LegsElmo,
    LegsHarper3,
    LegsJulio3,
    LegsJulio4,
    LegsMadrid,
    LegsNewly,
    LegsOdil3,
    LegsOdil4,
    LegsOslo,
    LegsPino,
    ...LegsRobu.reflections,
    LegsRoia,
    LegsTwist3
]);
export const LegsWithOffsetStandardDefault = new RawAliasReflection('LegsWithOffsetStandardDefault', [
    LegsBrago,
    LegsButterfly,
    LegsEbu,
    ...LegsEbonu3Double.reflections,
    LegsElmoDouble,
    ...LegsNovaro.reflections,
    LegsOxford,
    LegsPapillon,
    LegsPapillonStrak,
    ...LegsRobuDouble.reflections,
    LegsTrapezium,
    LegsUPoot,
    LegsXPoot
]);
export const LegsWithOffset = new RawAliasReflection('LegsWithOffset', [
    LegsClassico,
    ...LegsWithOffsetStandardDefault.reflections
]);
export const LegsWithLength = new RawAliasReflection('LegsWithLength', [
    Legs3D,
    LegsAxel,
    LegsDiamond,
    ...LegsEbonu.reflections,
    LegsFly,
    LegsHarper,
    LegsLivio,
    ...LegsLivioSchuin.reflections,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsRafino,
    LegsTPoot,
    LegsTPootRonde,
    LegsTwist4,
    ...LegsWithOffset.reflections
]);
export const LegsWithThickness = new RawAliasReflection('LegsWithThickness', [
    Legs3DRonde,
    LegsMPootRecht,
    LegsUPoot
]);
export const LegsWithWidth = new RawAliasReflection('LegsWithWidth', [
    Legs3D,
    LegsAxel,
    LegsBrago,
    LegsButterfly,
    LegsClassico,
    LegsDiamond,
    ...LegsEbonu.reflections,
    LegsEbu,
    LegsFly,
    LegsLivio,
    ...LegsLivioSchuin.reflections,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsPapillon,
    LegsPapillonStrak,
    LegsRafino,
    LegsTPoot,
    LegsTPootRonde,
    LegsTrapezium,
    LegsTwist4,
    LegsXPoot
]);
export const SteelLegs = new RawAliasReflection('SteelLegs', [
    Legs3D,
    Legs3DRonde,
    LegsAxel,
    LegsButterfly,
    LegsClassico,
    LegsDiamond,
    LegsEbonuStaal,
    LegsEbonu3Staal,
    LegsEbonu3DoubleStaal,
    LegsEbu,
    LegsFalke,
    LegsFly,
    LegsHarper,
    LegsHarper3,
    LegsJulio3,
    LegsJulio4,
    LegsLivioSchuinStaal,
    LegsMadrid,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsNewly,
    LegsNovaroStaal,
    LegsOdil3,
    LegsOdil4,
    LegsOxford,
    LegsPino,
    LegsRafino,
    LegsRobuStaal,
    LegsRobuDoubleStaal,
    LegsRoia,
    LegsTPoot,
    LegsTPootRonde,
    LegsTrapezium,
    LegsTwist3,
    LegsTwist4,
    LegsUPoot,
    LegsXPoot
]);
export const OakLegs = new RawAliasReflection('OakLegs', [
    LegsBrago,
    LegsCono,
    LegsEbonuEik,
    LegsEbonu3Eik,
    LegsEbonu3DoubleEik,
    LegsElmo,
    LegsElmoDouble,
    LegsLivio,
    LegsLivioSchuinEik,
    LegsNovaroEik,
    LegsOslo,
    LegsPapillon,
    LegsPapillonStrak,
    LegsRobuEik,
    LegsRobuDoubleEik
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    Top: Top.types,
    TopWithLengthAndWidth: TopWithLengthAndWidth.types,
    Legs: Legs.types,
    LegsEbonu: LegsEbonu.types,
    LegsEbonu3: LegsEbonu3.types,
    LegsEbonu3Double: LegsEbonu3Double.types,
    LegsLivioSchuin: LegsLivioSchuin.types,
    LegsNovaro: LegsNovaro.types,
    LegsRobu: LegsRobu.types,
    LegsRobuDouble: LegsRobuDouble.types,
    LegsWithDiameter: LegsWithDiameter.types,
    LegsWithOffsetStandardDefault: LegsWithOffsetStandardDefault.types,
    LegsWithOffset: LegsWithOffset.types,
    LegsWithLength: LegsWithLength.types,
    LegsWithThickness: LegsWithThickness.types,
    LegsWithWidth: LegsWithWidth.types,
    SteelLegs: SteelLegs.types,
    OakLegs: OakLegs.types
};
export const entities = {
    Table,
    TopCircle,
    TopDanishOval,
    TopHalfCircle,
    TopHalfOval,
    TopOval,
    TopRectangle,
    Legs3D,
    Legs3DRonde,
    LegsAxel,
    LegsBrago,
    LegsButterfly,
    LegsClassico,
    LegsCono,
    LegsDiamond,
    LegsEbonuEik,
    LegsEbonuStaal,
    LegsEbonu3Eik,
    LegsEbonu3Staal,
    LegsEbonu3DoubleEik,
    LegsEbonu3DoubleStaal,
    LegsEbu,
    LegsElmo,
    LegsElmoDouble,
    LegsFalke,
    LegsFly,
    LegsHarper,
    LegsHarper3,
    LegsJulio3,
    LegsJulio4,
    LegsLivio,
    LegsLivioSchuinEik,
    LegsLivioSchuinStaal,
    LegsMadrid,
    LegsMPootRecht,
    LegsMPootSchuin,
    LegsNewly,
    LegsNovaroEik,
    LegsNovaroStaal,
    LegsOdil3,
    LegsOdil4,
    LegsOslo,
    LegsOxford,
    LegsPapillon,
    LegsPapillonStrak,
    LegsPino,
    LegsRafino,
    LegsRobuEik,
    LegsRobuStaal,
    LegsRobuDoubleEik,
    LegsRobuDoubleStaal,
    LegsRoia,
    LegsTPoot,
    LegsTPootRonde,
    LegsTrapezium,
    LegsTwist3,
    LegsTwist4,
    LegsUPoot,
    LegsXPoot
};

//# sourceMappingURL=v3.js.map